import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Stethoscope, Pill, Flag, Link2 } from "lucide-react";
import { Link } from "react-router-dom";

export function ClinicalCatalogsCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-serif text-lg text-maroon-700 dark:text-amber-500">Clinical Catalogs</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <Link to="/admin/drugs">
          <Button variant="outline" className="w-full justify-start"><Pill size={16} className="mr-2" /> Drug Master</Button>
        </Link>
        <Link to="/admin/services">
          <Button variant="outline" className="w-full justify-start"><Stethoscope size={16} className="mr-2" /> Services & Fees</Button>
        </Link>
        <Link to="/admin/flags">
          <Button variant="outline" className="w-full justify-start"><Flag size={16} className="mr-2" /> Flags Catalog</Button>
        </Link>
      </CardContent>
    </Card>
  );
}
